import React, { useEffect, useRef } from 'react';
import Lottie, { LottieRefCurrentProps } from 'lottie-react';

interface LottieAnimationProps {
  animationData: any;
  loop?: boolean;
  autoplay?: boolean;
  speed?: number;
  width?: number | string;
  height?: number | string;
  className?: string;
  onComplete?: () => void;
}

export const LottieAnimation: React.FC<LottieAnimationProps> = ({
  animationData,
  loop = true,
  autoplay = true,
  speed = 1,
  width,
  height,
  className,
  onComplete,
}) => {
  const lottieRef = useRef<LottieRefCurrentProps>(null);

  useEffect(() => {
    // Set speed when the component mounts
    if (lottieRef.current && speed !== 1) {
      try {
        lottieRef.current.setSpeed(speed);
      } catch (error) {
        console.error('Failed to set Lottie animation speed:', error);
      }
    }
  }, [speed]);

  return (
    <Lottie
      animationData={animationData}
      loop={loop}
      autoplay={autoplay}
      lottieRef={lottieRef}
      style={{
        width: width || '100%',
        height: height || '100%'
      }}
      className={className}
      onComplete={onComplete}
      onDOMLoaded={(): void => {
        lottieRef.current?.setSpeed(speed ?? 1);
      }}
    />
  );
};
